import { apiUrlPrefix } from "~/shared/config"

/**
 * Представляет расширенные опции fetch
 */
export interface ApiRequest extends RequestInit {
	/** Выбрасывать исключение при ошибках 4xx и 5xx. Объектом ошибки будет ответ от сервера */
	throwError?: boolean
	/**
	 * Если равно true, то вместо ```Response``` вернет тело сообщения в формате _JSON_ (тип принимаемого сообщения, соотвественно, должен быть JSON).
	 * По сути, заменяет вызов ```await response.json()```
	 */
	toJSON?: boolean
	/**
	 * Токен доступа
	 */
	accessToken?: string | null
	/**
	 * Использовать JSON в качестве отправляемого и принимаемого типа сообщений. Можно использовать вместо аргумента ```json```
	 */
	json?: boolean
}

async function fetchApiBase(
	urlPrefix: string,
	url: string,
	options: ApiRequest | null = {},
	json = true,
	throwError = false,
) {
	if (options === null) {
		options = {}
	}

	options.credentials = "include"
	options.headers = options.headers || {}

	if (options.json !== undefined ? options.json : json) {
		const headers = new Headers(options.headers)
		headers.set("Accept", "application/json")
		headers.set("Content-Type", "application/json")

		options.headers = headers as Headers
	}

	/*options.headers = {
        ...options.headers,
        'x-access-token': options.accessToken ?? getAccessToken() ?? ""
    }*/

	const promise = fetch(`${urlPrefix}/${url}`, options)

	if (options.throwError !== undefined ? options.throwError : throwError) {
		const response = await promise

		if (!response.ok) {
			if (!options.toJSON) {
				throw response
			} else {
				throw await response.json()
			}
		}

		if (!options.toJSON) {
			return response
		} else {
			return response.json()
		}
	}

	if (!options.toJSON) {
		return promise
	} else {
		return (await promise).json()
	}
}

/**
 * Обертка вокруг `fetch`
 * По умолчанию, указываются заголовки `Accept` и `Content-Type` со значением `application/json`
 * @param url относительный url сервиса
 * @param options расширенные опции `fetch`
 * @param json использовать JSON в качестве отправляемого и принимаемого типа сообщений `deprecated - используйте options`
 * @param throwError выбрасывать исключение при ошибках 4xx и 5xx. Объектом ошибки будет тот же объект, который возвращается без выброса исключения (ответ от сервера) `deprecated - используйте options`
 */
export async function fetchApi(
	url: string,
	options?: ApiRequest | null,
	/** @deprecated */ json = true,
	/** @deprecated */ throwError = false,
) {
	return fetchApiBase(apiUrlPrefix, url, options, json, throwError)
}
